/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import axios from "axios";
import { getToken } from "../../../auth";

//BASE_URL
const API_URL = process.env.REACT_APP_API_URL;

const getReports = async (ChefId: any, filterData: any) => {
  const response = await axios
    .post(`${API_URL}get-reports/${ChefId}`, filterData);
    return response.data;
};
const getCategory = async () => {
  const res = await axios.get(
    `${API_URL}get-category`, getToken()
  );
  return res;
};

const getCuisine = async () => {
  const res = await axios.get(`${API_URL}get-cuisine`, getToken());
  return res;
};

const getType = async () => {
  const res = await axios.get(`${API_URL}get-type`, getToken());
  return res;
};

const getDish = async () => {
  const res = await axios.get(`${API_URL}get-dish`, getToken());
  return res;
};
const getOrderStatus = async () => {
  const res = await axios.get(`${API_URL}get-order-status`, getToken());
  return res;
};
const getUser = async () => {
  const res = await axios.get(`${API_URL}get-user`, getToken());
  return res;
};

export {
  getReports,
  getCategory,
  getCuisine,
  getType, getDish, getOrderStatus, getUser,

};
